import React, { useEffect, useMemo, useRef, useState } from 'react';
import { useHistory } from 'react-router-dom';
import cx from 'classnames';
import { getLinkFromCasinoGameData } from 'helpers/casino';

import { CasinoApi, Logger, useSettings } from '@atlas/core';
import { staticRoutes } from '@atlas/routing';
import { Loader } from '@atlas/ui';

import { useLocalBetslip } from 'common/Betslip/LocalBetslipContext';
import useTranslate from 'common/I18n/Interpreter';
import SeoPageText from 'components/SeoPage/SeoPageText';

const TVGames = () => {
  const t = useTranslate();

  const { quickBet: isQuickBet } = useSettings();
  const { betIdToEdit } = useLocalBetslip();

  const [gameDetailsData, setGameDetailsData] = useState({});
  const gameIFrame = useRef();
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const history = useHistory();

  useEffect(() => {
    const fetchGameDetails = async () => {
      setLoading(true);

      try {
        const res = await CasinoApi.fetchTVGameDetailsV2({});
        setGameDetailsData(res.data);
      } catch (error) {
        const errorCode = error?.code ?? '';
        const errorStatus = error?.status ?? '';

        if (errorCode.toString() === '401' || errorStatus.toString() === '401') {
          history.push(staticRoutes.signin);
        }

        setError(JSON.stringify(error, ' ', 2));
      } finally {
        setLoading(false);
      }
    };

    fetchGameDetails();
  }, []);

  const src = useMemo(() => {
    return getLinkFromCasinoGameData(gameDetailsData);
  }, [gameDetailsData]);

  useEffect(() => {
    const handleIFrameMessage = message => {
      try {
        if (typeof message.data === 'string') {
          const parsedData = JSON.parse(message.data);

          /*
              Parsed data example received from game iframe
              {
                "data":{
                  "hash":"/odds/atlas_2/1",
                  "windowName":"betgames_iframe_1",
                  "topPlius":1
                },
                "type":"iframeTop",
                "callback":"KRE52O0TFMFOGDV2NI97KP321DMPG90D"
              }
            */
          if (parsedData.type === 'iframeTop') {
            gameIFrame.current.contentWindow.scrollTo(0, parsedData.data.topPlius);
          }

          if (parsedData.type === 'new_resize') {
            // FIXME: Setting extra height to iframe
            const iframeElement =
              gameIFrame.current.contentDocument.getElementById('betgames_iframe_1');

            if (iframeElement) {
              iframeElement.height = `${parsedData.data.height}px`;
            }
          }
        }
      } catch (error) {
        Logger.error('Unable to handle iframe action', error);
      }
    };
    // gameIFrame.current
    window.addEventListener('message', handleIFrameMessage);

    return () => {
      window.removeEventListener('message', handleIFrameMessage);
    };
  }, []);

  const layoutToScrollClass = cx('layout-to-scroll', { quickbet: isQuickBet || betIdToEdit });

  return (
    <div className={layoutToScrollClass}>
      {loading && (
        <div className="loader-container align-center">
          <Loader className="absolute" />
        </div>
      )}

      {error && (
        <div className="casino-game-error">
          <span>{t('Error')}</span>
          <pre>{error}</pre>
        </div>
      )}

      {!error && !loading && gameDetailsData && (
        <div className="tv-games-container">
          <iframe ref={gameIFrame} src={src} />
        </div>
      )}
      <SeoPageText />
    </div>
  );
};

export default TVGames;
